module.exports = __webpack_public_path__ + "img/fundo_teorema_30_anos.13839b80.jpg";